'use client';

import { useTranslations } from 'use-intl';

import { DEFAULT_RENDERER_TYPE } from './project-response-chat.helpers';
import ConversationOverMessageFormRenderer from './project-response-conversation-over-message-form-renderer';
import { useHandsFreeQuestionPopupContext } from './project-usability-handsfree-question-popup-context';

interface Props {
  onConversationOver: () => void;
  conversationOverText?: string | null;
}

export default function ProjectUsabilityHandsFreeQuestionPopupFooter({
  onConversationOver,
  conversationOverText,
}: Props) {
  const t = useTranslations('Usability');
  const { messageType } = useHandsFreeQuestionPopupContext();

  return (
    <ConversationOverMessageFormRenderer
      onClick={onConversationOver}
      conversationOverText={conversationOverText || t('finishAndClose')}
      type={messageType ?? DEFAULT_RENDERER_TYPE}
      showIcon
      className='rounded-2xl py-2 text-sm'
    />
  );
}
